import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { WHATSAPP_NUMBER } from "@/components/WhatsAppFloatingButton";
import { useLanguage } from "@/contexts/LanguageContext";

const HeroSection = () => {
  const { t } = useLanguage();
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(t("hero.whatsapp"))}`;

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      <picture>
        <source
          type="image/avif"
          srcSet="/hero-barra-768.avif 768w, /hero-barra-1600.avif 1600w"
          sizes="100vw"
        />
        <source
          type="image/webp"
          srcSet="/hero-barra-768.webp 768w, /hero-barra-1600.webp 1600w"
          sizes="100vw"
        />
        <img
          src="/hero-barra-1600.webp"
          alt="Vista aérea da Barra da Tijuca com prédios de luxo à beira-mar"
          className="absolute inset-0 w-full h-full object-cover"
          width={1600}
          height={900}
          loading="eager"
          decoding="async"
          // @ts-expect-error fetchpriority is a valid HTML attribute
          fetchpriority="high"
        />
      </picture>

      <div className="absolute inset-0 bg-gradient-to-r from-primary/80 via-primary/50 to-transparent" />
      <div className="relative z-10 container mx-auto px-4 py-20">
        <div className="max-w-2xl animate-fade-in-up">
          <span className="inline-block rounded bg-accent px-4 py-1.5 text-sm font-semibold text-accent-foreground mb-6 font-body">
            {t("hero.badge")}
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-card leading-tight mb-6">
            {t("hero.title")}
          </h1>
          <p className="text-lg text-card/90 mb-8 font-body leading-relaxed">
            {t("hero.subtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button variant="hero" size="lg" asChild>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" title="Falar com a TopClass Imóveis no WhatsApp">
                <Phone className="h-5 w-5" />
                {t("hero.cta")}
              </a>
            </Button>
            <Button variant="heroOutline" size="lg" asChild>
              <a href="#imoveis" title="Ver imóveis disponíveis">{t("hero.cta2")}</a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
